import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap is imported
import { FaEnvelope } from 'react-icons/fa'; // Import a mail icon from react-icons

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // const response = await fetch('/.netlify/functions/contactForm', {
      //   method: 'POST',
      //   body: JSON.stringify({
      //     name,
      //     email,
      //     message,
      //   }),
      // });
      // console.log(response)
      // const data = await response.json();

      // if (response.status === 200) {
      //   setSuccessMessage(data.message);
      //   setErrorMessage('');
      //   setName('');
      //   setEmail('');
      //   setMessage('');
      // } else {
      //   setErrorMessage(data.message);
      //   setSuccessMessage('');
      // }
    } catch (error) {
      setErrorMessage(error.message);
      setSuccessMessage('');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', // Full viewport height to center vertically
        padding: '20px',
        backgroundColor: 'transparent', // Light background color
      }}
    >
      <div className="card" style={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}>
        <div className="card-body">
          <FaEnvelope size={60} style={{ color: 'rgb(87 114 182)', marginBottom: '20px' }} />
          <h1 className="card-title">Get in Touch!</h1>
          <p className="card-text">
            Got a question, some feedback, or just want to chat about classic motorcycles? 
            Drop us a message below, and we'll get back to you soon.
          </p>

          {successMessage && <div className="alert alert-success">{successMessage}</div>}
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <textarea
                className="form-control"
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                rows="5"
                required
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;